let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("4LD9X")]).then(() => parcelRequire('7G6RL'));